import { render, staticRenderFns } from "./JobalertUpdate.vue?vue&type=template&id=06bfc0be"
import script from "./JobalertUpdate.vue?vue&type=script&lang=js"
export * from "./JobalertUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports